var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.167 15.833V8.59a1.336 1.336 0 01.538-1.077l4.487-3.398c.235-.18.503-.269.805-.269.302 0 .572.09.81.27l4.488 3.397a1.335 1.335 0 01.539 1.077v7.243a.8.8 0 01-.25.584.8.8 0 01-.584.25h-2.82a.651.651 0 01-.48-.194.652.652 0 01-.194-.48V12.02c0-.19-.064-.35-.193-.48a.652.652 0 00-.48-.193H9.166c-.19 0-.35.065-.48.194a.651.651 0 00-.193.48v3.973c0 .191-.064.351-.193.48a.65.65 0 01-.48.194H5a.8.8 0 01-.584-.25.8.8 0 01-.25-.584z",
    fill: "url(#home_svg__paint0_linear_9_5855)",
    opacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "home_svg__paint0_linear_9_5855",
    x1: 10,
    y1: 0.333,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33C4E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A65F2"
  })))));
}
export default SvgHome;